import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { KmsService } from "../../../kms.service";
import { SwMassageBoxService } from "../../../../../librarys/serves/sw-massage-box.service";
import { SwCreateModalComponentService } from "../../../../../librarys/serves/sw-create-modal-component.service";
import { SwMassageConfirmComponent } from "../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component";
import { RelationViewComponent } from "../relation-view/relation-view.component";
import { RelationCreateComponent } from "../relation-create/relation-create.component";
import { InstanceModuleService } from "../../../serves/instance/instance.module";
import { SwJwtService } from "src/app/librarys/serves/sw-jwt.service";
declare var $;
@Component({
  selector: "app-relation-query",
  templateUrl: "./relation-query.component.html",
  styleUrls: ["./relation-query.component.css"],
})
export class RelationQueryComponent implements OnInit {

  // 删除确认组件
  @ViewChild("tirm1") tirm1: SwMassageConfirmComponent;
  // 接收父组件的数据：tabId
  @Input() tabId: string;
  // 接收父组件的数据：实体ID
  @Input() instanceId: any;
  // 接收父组件的数据：状态
  @Input() state: string = "edit";
  // 头部搜索内容
  searchDatas = {
    endNodeName: "",   // 指向实体名称
    endConceptId:"",        // 指向实体概念id
    relationName: "",   // 关系名称
  };

  // 表格数据内容
  relationDatas = [];

  // 表格数据选中内容
  selectTableDatas = [];

  // 表格是否显示加载中
  isLoading: boolean = false;

  // 表格分页组件
  pageBase:any = {
    current: 1,
    size: 10,
  };

  // 表格操作按钮
  toolbar = [
    {
      status: true,
      functionCode: "add",
      functionName: "创建关系",
      icon: "glyphicon glyphicon-plus",
      children: [],
    },
    {
      status: true,
      functionCode: "delete",
      functionName: "批量删除",
      icon: "glyphicon glyphicon-remove",
      children: [],
    },
  ];
  // 概念树数据
  ontologyTreeDatas:any = [];
  readonlySelfIds:any = [];
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private instanceModuleService: InstanceModuleService,
    private jwt: SwJwtService,
    private create: SwCreateModalComponentService
  ) {}

  ngOnInit() {
    this.getOnlogyTreePageList();
  }

  ngOnChanges() {
    if (this.tabId == "002" && this.instanceId) {
      if (this.state === "view") {
        this.toolbar = [];
      }
      this.getRelationDatas();
    }
  }

  // 获取关系表格数据
  getRelationDatas() {
    this.isLoading = true;
    this.searchDatas.relationName = $.trim(this.searchDatas.relationName);
    this.searchDatas.endNodeName = $.trim(this.searchDatas.endNodeName);
    let params = {
      current: this.pageBase.current,
      size: this.pageBase.size,
      relationshipName: this.searchDatas.relationName,
      conceptId: this.searchDatas.endConceptId,
      startNode: {
        nodeId: this.instanceId
      },
      endNode: {
        nodeName: this.searchDatas.endNodeName
      }
    };
    this.kmsService.getRelationshipList(params).subscribe((data) => {
      this.isLoading = false;
      if (data.code == "200") {
        this.pageBase = data.data;
        this.relationDatas = data.data.records;
      } else {
        this.message.waring(data.msg);
      }
    });
  }

  // 头部搜索查询方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10,
    };
    this.getRelationDatas();
  }

  // 指向实体名称enter键搜索
  handelEnterSearch(event) {
    if (event.keyCode == 13) {
      this.handleSelectClick();
    }
  }

  // 头部搜索重置方法
  handleReloadClick() {
    // 重置搜索条件
    this.searchDatas = {
      endNodeName: "",
      endConceptId: "",
      relationName: "",
    };
    // 重置分页条件
    this.pageBase = {
      current: 1,
      size: 10,
    };

    this.getRelationDatas();
  }

  // 表格按钮点击事件
  handleOperationClick(event) {
    switch (event) {
      case "add":
        this.handleAddClick();
        break; // 关系创建
      case "delete":
        this.handleDeleteClick();
        break; // 删除
    }
  }

  // 新增关系信息
  handleAddClick() {
    let datas = {
      upOrAdd: 'add',
      sourceUUID: this.instanceId
    };
    this.create.createModal(
      RelationCreateComponent,
      datas,
      this.handleSelectClick.bind(this)
    );
  }

  // 编辑关系信息
  handleEditClick(item) {
    //禁止冒泡
    event.stopPropagation();
    let datas = {
      upOrAdd: 'edit',
      sourceUUID: item.sourceUUID,
      properties: item.properties
    };
    this.create.createModal(
      RelationCreateComponent,
      datas,
      this.getRelationDatas.bind(this)
    );
  }

  // 查看关系信息
  handleViewClick(item) {
    //禁止冒泡
    event.stopPropagation();
    let datas = {
      startNodeId: item.sourceUUID,
      uuid: item.properties.uuid,
    };
    this.create.createModal(RelationViewComponent, datas);
  }

  // 删除关系信息
  handleDeleteClick(item?) {
    let params = [];
    if (item) {
      //禁止冒泡
      event.stopPropagation();
      params = [
        {
          startNodeId: item.sourceUUID,
          uuid: item.properties.uuid,
        },
      ];
    } else {
      if (this.selectTableDatas.length > 0) {
        for (let i = 0; i < this.selectTableDatas.length; i++) {
          params.push({
            startNodeId: this.selectTableDatas[i].sourceUUID,
            uuid: this.selectTableDatas[i].properties.uuid,
          });
        }
      } else {
        this.message.info("请选择需要删除的关系数据！");
        return;
      }
    }

    // 删除方法
    this.tirm1.openCLick("确认删除吗？", (data) => {
      if (data) {
        this.kmsService.deleteRelationshipById(params).subscribe((result) => {
          if (result.code == 200) {
            this.message.success("数据删除成功！");
            this.getRelationDatas();
          }
        });
      }
    });
  }

  // 表格选中数据
  handleSelectData(event) {
    this.selectTableDatas = event;
  }

  // 表格分页切换方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getRelationDatas();
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    this.kmsService.getConceptTreeData({}).subscribe(
        data => {
            if (data.code == 200) {
                if (!data.data) {
                    this.ontologyTreeDatas = [];
                }
                this.ontologyTreeDatas = data.data;
                // 获取不可选择的概念树节点
                this.ontologyTreeDatas.forEach(item => {
                    if(this.ontologyTreeDatas.filter(item1 => item1.pid == item.id).length > 0){
                        this.readonlySelfIds.push(item.id);
                    }
                })
            }
        }
    );
  }

  // 点击选中关系存储关系信息为添加质检记录做准备
  setAttrRecord(data){
    if(this.state == 'Verify'){
      const relationName = data.properties.reverseRelationName ? data.properties.relationshipName+"（"+data.properties.reverseRelationName+"）" : data.properties.relationshipName;
      let verifyConfig = {
          uuid: this.instanceModuleService.uuid2(),
          contentName: data.sourceProperties.nodeName+'-'+relationName+'-'+data.targetProperties.nodeName,      // 属性名称
          contentModule: '关系配置',  // 错误模块
          foreignId: this.instanceId,  // 实体id
          contentId: data.properties.uuid,    // 属性id
          recordType: 1,    // 1 实体  2 标记
      }
      this.jwt.setToKen('instanceVerifyConfig',JSON.stringify(verifyConfig));
      this.message.info('选中关系数据：'+verifyConfig.contentName);
    }
 }
}
